import * as angular from 'angular';
import * as moment from 'moment';
import * as momentTz from 'moment-timezone';
import { IView, IViewItem, IDirectiveScopeInternal, IModelController } from '../definitions';
import { IProviderOptions } from '../provider';
import { isValidMoment } from '../utility';

export default class MonthView implements IView {
    public perLine: number = moment.weekdays().length;
    public rows: { [index: number]: IViewItem[] } = [];
    public headers: string[];

    constructor(
        private $scope: IDirectiveScopeInternal,
        private $ctrl: IModelController,
        private provider: IProviderOptions) { }

    public render(): string {
        let month: number = this.$scope.view.moment.month();
        let day: moment.Moment = this.$scope.view.moment.clone().startOf('month').startOf('week').hour(12);
        let rows: { [week: number]: IViewItem[] } = {};
        let firstWeek: number = day.week();
        let lastWeek: number = firstWeek + 5;

        this.rows = [];

        for (let week = firstWeek; week <= lastWeek; week++) {
            let index = 0;
            rows[week] = Array.apply(null, Array(this.perLine)).map(() => {
                let daysFromEnd = day.clone();
                let selectable = this.$scope.limits.isSelectable(day, 'day');
                let date = <IViewItem> {
                    index: day.date(),
                    label: day.format(this.provider.daysFormat),
                    year: day.year(),
                    month: day.month(),
                    date: day.date(),
                    class: [
                        this.$scope.keyboard && day.isSame(this.$scope.view.moment, 'day') ? 'highlighted' : '',
                        !!this.$scope.today && day.isSame(new Date(), 'day') ? 'today' : '',
                        !selectable ? 'disabled' : isValidMoment(this.$ctrl.$modelValue) && day.isSame(this.$ctrl.$modelValue, 'day') && day.month() == month ? 'selected' : '',
                        (this.$scope.startDateRange && this.$scope.endDateRange && day.isSame(this.$scope.startDateRange, 'day')) || (this.$scope.startDateRange && day.month() == month && day.isSame(this.$scope.startDateRange, 'day')) ? 'start-date' : '',
                        (this.$scope.startDateRange && this.$scope.endDateRange && day.isSame(this.$scope.endDateRange, 'day')) || (day.month() == month && this.$scope.endDateRange && day.isSame(this.$scope.endDateRange, 'day')) ? 'end-date' : '',
                        day.month() !== month ? 'day-not-in-current-month' : '',
                        momentTz(this.$scope.endDateRange).tz(this.$scope.timezone).isSame(daysFromEnd.clone().add(1, 'days'), 'days') && this.$scope.endDateRange !== undefined && !daysFromEnd.isSame(this.$scope.startDateRange, 'days') && !momentTz(this.$scope.startDateRange).tz(this.$scope.timezone).isSame(this.$scope.endDateRange, 'days') && index !== 6 ? 'day-before-end-date' : '',
                        (this.$scope.startDateRange !== undefined && this.$scope.endDateRange !== undefined) && (day.isBetween(this.$scope.startDateRange, this.$scope.endDateRange)) && !day.isSame(this.$scope.startDateRange, 'days') && !day.isSame(this.$scope.endDateRange, 'days') ? 'in-between-range' : ''
                    ].join(' ').trim(),
                    selectable: selectable && (day.month() === month || day.isBetween(this.$scope.startDateRange, this.$scope.endDateRange)) ? true : false
                };

                index++;
                day.add(1, 'days');
                return date;
            });
        }

        // object to array - see https://github.com/indrimuska/angular-moment-picker/issues/9
        angular.forEach(rows, (row: IViewItem[]) => (<IViewItem[][]>this.rows).push(row));
        // render headers

        moment.locale(this.$scope.locale)
        this.headers = moment.weekdaysShort().map((d: string, i: number) => momentTz().tz(this.$scope.timezone).locale(this.$scope.locale).startOf('week').add(i, 'day').format('ddd'));

        return this.$scope.view.moment.locale(this.$scope.locale).format('MMMM YYYY');
    }

    public set(day: IViewItem): void {
        if (!day.selectable) return;

        this.$scope.view.moment.year(day.year).month(day.month).date(day.date);

        this.$scope.view.update();
        this.$scope.view.change('day');
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/date-picker/angular-moment-picker/views/monthView.ts